import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.332 20c0 6.441-5.223 11.668-11.664 11.668C5.223 31.668 0 26.441 0 20S5.223 8.332 11.668 8.332c6.441 0 11.664 5.227 11.664 11.668m0 0",
      style: {"stroke":"none","fill-rule":"evenodd","fill":"#ea001b","fill-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M40 20c0 6.441-5.223 11.668-11.668 11.668-6.441 0-11.664-5.227-11.664-11.668S21.891 8.332 28.332 8.332C34.777 8.332 40 13.559 40 20m0 0",
      style: {"stroke":"none","fill-rule":"evenodd","fill":"#ffa200","fill-opacity":".8"}
    }, null, -1)
  ])))
}
export default { render: render }